import Vue from 'vue';
export default Vue.component('ed-modal', { 
  data: () => {
    return {
      show: false
    }
  },
  created() {
    setTimeout(() => {
      this.show = true;
    }, 300);
  }
});